import { useEffect, useState } from "react";

// True when the app is launched as an installed PWA. iOS Safari exposes a
// non-standard `navigator.standalone`; everywhere else, the
// `display-mode: standalone` media query is the standard signal. Check both
// so users see the affordances regardless of platform.
export function usePwaMode(): boolean {
  const [isPwa, setIsPwa] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia("(display-mode: standalone)");
    const update = () => {
      const matches = mql.matches;
      const iosStandalone =
        (window.navigator as Navigator & { standalone?: boolean }).standalone === true;
      setIsPwa(matches || iosStandalone);
    };
    update();
    mql.addEventListener("change", update);
    return () => mql.removeEventListener("change", update);
  }, []);

  return isPwa;
}
